import { useForm } from 'react-hook-form';
import { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from 'src/ui/components/Toast/ToastContainer';
import styles from './ServiceCreate.module.scss';
import { Heading } from '../../../ui/components/Heading/Heading';
import { Input } from '../../../ui/components/Input/Input';
import { Grid } from '../../../ui/components/PageBuilder/Grid/Grid';
import { Time } from '../../../ui/components/Time/Time';
import { Button } from '../../../ui/components/Button/Button';
import { useGQLMutation } from '../../../ui/utils/graphql';
import { CREATE_SERVICE } from '../../../graphql/service';
import { Service } from '../../../gql/graphql';
import { InitialContext } from '../../Layout/Layout';

interface CreateServiceForm {
  name: string;
  durationInSec: string;
  price: string;
}

export const ServiceCreate = () => {
  const { setToast } = useToast();
  const { mutation } = useGQLMutation<
    Service,
    Pick<Service, 'name' | 'price' | 'durationInSec' | 'companyId' | 'parent'>
  >(CREATE_SERVICE, {
    onCompleted: (data) => {
      if (data) {
        setToast({
          content: `Service ${data.name} created successfully!`,
          type: 'success',
        });
        navigate('/services');
      }
    },
    onError: (error) => {
      setToast({
        content: 'Error creating service. Please try again.',
        type: 'error',
      });
    },
  });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const context = useContext(InitialContext);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CreateServiceForm>();

  const onSubmit = (service: CreateServiceForm) => {
    const durationInSec = service.durationInSec
      .split(':')
      .map((time) => Number(time))
      .reduce(
        (prev, curr, currIndex) => prev + curr * 60 ** (2 - currIndex),
        0
      );

    mutation({
      variables: {
        name: service.name,
        price: Number(service.price),
        durationInSec,
        companyId: context.company.id,
        parent: searchParams.get('service') || null,
      },
    });
  };
  return (
    <div className={styles.root}>
      <Heading headingLevel="h1" className={styles.heading}>
        {`Crear ${searchParams.get('service') ? 'subservicio' : 'servicio'}`}
      </Heading>
      <p className={styles.description}>
        Selecciona las caracteristicas que mejor se adecuen a tu{' '}
        {`${searchParams.get('service') ? 'subservicio' : 'servicio'}`}
      </p>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <Grid classname={styles.grid} gridColumns={4}>
          <Input
            register={register('name', {
              minLength: {
                value: 4,
                message: "The min length it's of 4",
              },
              required: {
                value: true,
                message: 'Este campo es requerido',
              },
            })}
            errorMessage={errors?.name?.message}
            label="Nombre de servicio *"
            placeholder="Ejemplo: Consulta general"
          />
          <Input
            register={register('price', {
              required: {
                value: true,
                message: 'Este campo es requerido',
              },
            })}
            type="number"
            label="Precio del servicio *"
            placeholder="Ejemplo: 150"
            errorMessage={errors?.price?.message}
          />
          <Time
            register={register('durationInSec', {
              required: {
                value: true,
                message: 'Este campo es requerido',
              },
            })}
            label="Duración del servicio *"
            name="durationInSec"
            errorMessage={errors?.durationInSec?.message}
            setValue={setValue}
          />
        </Grid>
        <div className={styles.buttons}>
          <Button onClick={() => navigate('/services')}>Cancel</Button>
          <Button btnStyle="secondary" type="submit">
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};
